/* unplugin-vue-components disabled */import script from "./InterviewQuestionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./InterviewQuestionDetail.vue?vue&type=script&setup=true&lang=js"

import "./InterviewQuestionDetail.vue?vue&type=style&index=0&id=1570816c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1570816c"]])

export default __exports__